/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface VenueTransfer {
  id?: number;
  routeId?: number;
  amount?: number;
  status?: VenueTransfer.StatusEnum;
  sourceVenueTransferId?: string;
  destinationVenueTransferId?: string;
  sourceVenueStatus?: string;
  destinationVenueStatus?: string;
  txHash?: string;
  sourceVenueFee?: number;
  sourceVenueFeeAssetName?: string;
  rawData?: string;
  errorMessage?: string;
  createTime?: string;
  submitTime?: string;
  releaseTime?: string;
  landTime?: string;
  sourceTransferId?: number;
  destinationTransferId?: number;
}
export namespace VenueTransfer {
  export const StatusEnum = {
    Requested: 'REQUESTED',
    Submitted: 'SUBMITTED',
    Unknown: 'UNKNOWN',
    Released: 'RELEASED',
    Landed: 'LANDED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
